import { EventEmitter } from '@flipster/utils/event-emitter';
import type { RttData } from '@flipster/utils/rtt-tracking';

export interface RttEmitterEvents {
  update: RttData;
}

export const rttEmitter = new EventEmitter<RttEmitterEvents>();
